// Centralized site content for SIPL
import {
  Sun, Recycle, Droplets, ClipboardList, Wrench, ShoppingBag,
  Leaf, Sprout, FlaskConical, Recycle as RecycleIcon,
  Droplet, GraduationCap, FileText, MapPinned, Gavel, Truck,
  Train, Building2, Anchor, Cpu, Landmark, ShieldCheck,
  Award, BookOpen, Lightbulb, BadgeCheck,
} from "lucide-react";

export const COMPANY = {
  name: "Sunforce Infra Pvt. Ltd.",
  short: "SIPL",
  tagline: "Powering Sustainable growth aiming cleaner environment through Green Energy and Transforming Waste into Wealth",
  subtagline:
    "End-to-end solar, waste management, and infrastructure solutions for a greener and Happier future.",
  founded: 2016,
  hq: "Noida, India",
  phone: "+91 7827729936",
  phoneRaw: "917827729936",
  email: "contact@sunforceinfra.in",
  address:
    "CO1-A, Max Towers, Sector 16B, Noida, Distt: Gautam Budh Nagar, UP, 201301",
  cin: "U40106DL2016PTC298411",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Leadership", href: "#leadership" },
  { label: "Why SIPL", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export const STATS = [
  { value: 8, suffix: "+", label: "Years of Operations" },
  { value: 1000, suffix: "+", label: "Solar Units Supplied" },
  { value: 50, suffix: "+", label: "Water ATMs Deployed" },
  { value: 5, suffix: "", label: "ULB Waste Projects (Jharkhand)" },
];

export const SERVICES = [
  {
    id: "solar",
    title: "Solar Energy Solutions",
    icon: Sun,
    accent: "bg-sipl-accent/10 text-sipl-accent",
    blurb:
      "Turnkey EPC, long-term O&M and a curated marketplace for solar hardware.",
    items: [
      { icon: Wrench, text: "Installation & Commissioning (EPC)" },
      { icon: ClipboardList, text: "O&M Contracts" },
      { icon: ShoppingBag, text: "Solar Marketplace — Panels, Inverters, Batteries" },
    ],
    image:
      "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc4MzQ1NDAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "waste",
    title: "Waste Management",
    icon: Recycle,
    accent: "bg-sipl-secondary/10 text-sipl-secondary",
    blurb:
      "Circular-economy solutions across municipal, agricultural and bio-waste streams.",
    items: [
      { icon: Leaf, text: "Municipal Solid Waste" },
      { icon: Sprout, text: "Agricultural Waste" },
      { icon: FlaskConical, text: "Bio Waste Processing" },
      { icon: RecycleIcon, text: "Resource Recovery" },
    ],
    image:
      "https://images.unsplash.com/photo-1714736825432-53f828422c9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHx3YXN0ZSUyMG1hbmFnZW1lbnQlMjByZWN5Y2xpbmclMjBmYWNpbGl0eSUyMG1vZGVybnxlbnwwfHx8fDE3NzgzNDU0MDF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "rural",
    title: "Rural Infrastructure",
    icon: Droplets,
    accent: "bg-sipl-primary/10 text-sipl-primary",
    blurb:
      "Last-mile infrastructure that reaches communities — clean water and inclusive education.",
    items: [
      { icon: Droplet, text: "Water ATM" },
      { icon: Droplets, text: "Drinking Water Systems" },
      { icon: GraduationCap, text: "Education ATM" },
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/82a49ca8-8fc9-4244-8751-6e775d55f9dd/images/1a0a8e41a1ce2e3e046c5ada80fbaa9b70bf8353663b513afcf76619fa21db46.png",
  },
  {
    id: "consultancy",
    title: "Consultancy & PMC",
    icon: ClipboardList,
    accent: "bg-sipl-accent/10 text-sipl-accent",
    blurb:
      "Project management consultancy backed by 40+ years of public-sector expertise.",
    items: [
      { icon: FileText, text: "Feasibility Reports" },
      { icon: MapPinned, text: "Site Assessment" },
      { icon: BookOpen, text: "Detailed Project Reports (DPR)" },
      { icon: Gavel, text: "E-auction & Supply Chain" },
    ],
    image:
      "https://static.prod-images.emergentagent.com/jobs/82a49ca8-8fc9-4244-8751-6e775d55f9dd/images/a2a6c4dd9a166624c3828c8b5680a1fcf1c20df4e00abefbc55720be259ad8c5.png",
  },
];

export const PROJECTS = [
  {
    id: "rooftop-100kw",
    title: "Rooftop Solar — 100 KW Sites",
    location: "Multi-site, North India",
    capacity: "100 KW per site",
    duration: "Phased Rollout",
    impact: "≈ 1.4 lakh kWh/yr clean energy per site",
    tag: "Solar EPC",
    image:
      "https://images.unsplash.com/photo-1726776230760-ae81dc9d4e55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc4MzQ1NDAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "solar-supply",
    title: "Solar Product Supply — 1000+ Units",
    location: "Pan-India dispatch",
    capacity: "1000+ units",
    duration: "FY rolling",
    impact: "Distribution to OEMs, integrators and direct buyers",
    tag: "Marketplace",
    image:
      "https://images.unsplash.com/photo-1726866492047-7f9516558c6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxzb2xhciUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc4MzQ1NDAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "water-atm",
    title: "Water ATM Installations — 50 Units",
    location: "Rural belts, multiple states",
    capacity: "50 deployed",
    duration: "Multi-quarter rollout",
    impact: "Safe drinking water access for 50,000+ residents",
    tag: "Rural Infra",
    image:
      "https://images.unsplash.com/photo-1760873059715-7c7cfbe2a2c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxydXJhbCUyMGNsZWFuJTIwZHJpbmtpbmclMjB3YXRlciUyMGNvbW11bml0eXxlbnwwfHx8fDE3NzgzNDU0MDF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "msw-jharkhand",
    title: "Municipal Waste Management — 3 ULBs",
    location: "Jharkhand, India",
    capacity: "5 Urban Local Bodies",
    duration: "Multi-year contract",
    impact: "Door-to-door collection, segregation & resource recovery",
    tag: "MSW / PMC",
    image:
      "https://images.unsplash.com/photo-1714736825432-53f828422c9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHx3YXN0ZSUyMG1hbmFnZW1lbnQlMjByZWN5Y2xpbmclMjBmYWNpbGl0eSUyMG1vZGVybnxlbnwwfHx8fDE3NzgzNDU0MDF8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const CLIENTS = [
  { name: "Indian Railways", icon: Train },
  { name: "Northern Railways", icon: Train },
  { name: "Urban Dev. Dept., Jharkhand", icon: Landmark },
  { name: "Municipal Corporations", icon: Landmark },
];

export const LEADERSHIP = [
  {
    name: "Anil Babu Sharma",
    role: "Managing Director",
    initials: "AB",
    bio:
      "40+ years of industrial leadership across BHEL and Central Electronics Limited (CEL). Expertise in project finance, renewable energy and large-scale execution.",
    tags: ["Renewable Energy", "Project Finance", "BHEL", "CEL", "40+ yrs"],
    linkedin: "https://www.linkedin.com/in/anil-babu-sharma-65614236/",
  },
  {
    name: "Ashutosh Bhardwaj",
    role: "Managing Partner",
    initials: "AS",
    bio:
      "10+ years of experience as Strategy & Consulting leader with deep experience across the energy sector — bringing structured execution to PMC, DPR and policy advisory engagements.",
    tags: ["Strategy", "Consulting", "Energy Policy"],
    linkedin: "https://www.linkedin.com/in/ashutoshbhar/",
  },
];

export const WHY_SIPL = [
  {
    title: "Expertise in Renewable Projects",
    desc: "Decades of execution across solar EPC, O&M and government-led infrastructure mandates.",
    icon: Award,
    span: "lg:col-span-6",
    tone: "primary",
  },
  {
    title: "Service Excellence",
    desc: "End-to-end delivery — concept, DPR, build, commissioning and lifetime O&M.",
    icon: ShieldCheck,
    span: "lg:col-span-6",
    tone: "secondary",
  },
  {
    title: "Innovation",
    desc: "Bringing modern engineering and circular-economy thinking to legacy infrastructure.",
    icon: Lightbulb,
    span: "lg:col-span-4",
    tone: "accent",
  },
  {
    title: "Knowledge & Training",
    desc: "On-ground capacity building for operators, ULBs and rural communities.",
    icon: GraduationCap,
    span: "lg:col-span-4",
    tone: "neutral",
  },
  {
    title: "Trusted by Government",
    desc: "Empanelled with Indian Railways, ULBs, Port Trusts and PSUs.",
    icon: BadgeCheck,
    span: "lg:col-span-4",
    tone: "primary",
  },
];

export const CERTIFICATIONS = [
  { label: "MSME Registered", desc: "Udyam Registered Enterprise" },
  { label: "GST Compliant", desc: "Active GSTIN, Pan-India operations" },
  { label: "ISO-aligned QMS", desc: "Quality, safety & ESG-aligned processes" },
  { label: "Government Empanelled", desc: "Active vendor across multiple ULBs & PSUs" },
];

export const TESTIMONIALS = [
  {
    quote:
      "SIPL's execution discipline made our rooftop solar rollout exceptionally smooth. Their O&M is hands-on and outcome-driven.",
    author: "Procurement Lead",
    org: "Public Sector Utility",
  },
  {
    quote:
      "The Water ATM deployment changed access to safe drinking water in our cluster. Communities trust the model.",
    author: "Project Officer",
    org: "Urban Local Body, Jharkhand",
  },
  {
    quote:
      "Strong consultancy backbone — DPRs were investor-ready and accelerated our funding cycle by months.",
    author: "Managing Partner",
    org: "Infrastructure Developer",
  },
];

export const BLOG_PREVIEW = [
  {
    title: "Why India's MSW story is the next big infra opportunity",
    tag: "Waste Management",
    minutes: 6,
    image:
      "https://images.unsplash.com/photo-1714736825432-53f828422c9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHx3YXN0ZSUyMG1hbmFnZW1lbnQlMjByZWN5Y2xpbmclMjBmYWNpbGl0eSUyMG1vZGVybnxlbnwwfHx8fDE3NzgzNDU0MDF8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Rooftop solar economics in 2026 — what's actually changed",
    tag: "Solar EPC",
    minutes: 5,
    image:
      "https://images.unsplash.com/photo-1726776230760-ae81dc9d4e55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxzb2xhciUyMHBvd2VyJTIwcGxhbnQlMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc4MzQ1NDAxfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Water ATMs & the case for community-anchored utilities",
    tag: "Rural Infra",
    minutes: 4,
    image:
      "https://images.unsplash.com/photo-1760873059715-7c7cfbe2a2c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxydXJhbCUyMGNsZWFuJTIwZHJpbmtpbmclMjB3YXRlciUyMGNvbW11bml0eXxlbnwwfHx8fDE3NzgzNDU0MDF8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/82a49ca8-8fc9-4244-8751-6e775d55f9dd/images/891c8424c8917099e74f4212fe944e6522567e4cc646630365b6c100f8272460.png";

export const SERVICE_INTERESTS = [
  "Solar EPC / Rooftop",
  "Solar O&M",
  "Solar Marketplace",
  "Municipal Solid Waste",
  "Bio / Agri Waste",
  "Water ATM / Drinking Water",
  "Education ATM",
  "Consultancy / DPR",
  "Other",
];
